var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { MappingExpressionBase } from "./MappingExpressionBase";
export class ConcatExpression extends MappingExpressionBase {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "FieldPaths");
    /**
     */
    __publicField(this, "Separator");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ConcatExpression
     */
    __publicField(this, "$type", "V1.DocumentTemplates.ConcatExpression");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      if (_data["FieldPaths"] && _data["FieldPaths"].constructor === Array) {
        this.FieldPaths = [];
        for (let item of _data["FieldPaths"]) {
          this.FieldPaths.push(item);
        }
      }
      this.Separator = _data["Separator"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    if (this.FieldPaths && this.FieldPaths.constructor === Array) {
      _data["FieldPaths"] = [];
      for (let item of this.FieldPaths) {
        _data["FieldPaths"].push(item);
      }
    }
    _data["Separator"] = this.Separator;
    return _data;
  }
}
